import type { ModivcareBillableTrip } from '@bambi/api-client/schemas';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface ModivcareState {
  // Filters
  filterSentAtGte?: string;
  filterSentAtLte?: string;
  // Selection, keyed by billable trip id
  selectedRows: Record<
    ModivcareBillableTrip['trip_id'],
    ModivcareBillableTrip | null
  >;
  bulkPriceModal: {
    isOpen: boolean;
    billableTripsToPrice: ModivcareBillableTrip[];
  };
}

export const initialState: ModivcareState = {
  selectedRows: {},
  bulkPriceModal: {
    isOpen: false,
    billableTripsToPrice: [],
  },
};

export const modivcareSlice = createSlice({
  name: 'modivcare',
  initialState,
  reducers: {
    setFilterSentAtRange(
      state,
      action: PayloadAction<{ rangeStart?: string; rangeEnd?: string }>
    ) {
      state.filterSentAtGte = action.payload.rangeStart;
      state.filterSentAtLte = action.payload.rangeEnd;
      state.selectedRows = {};
    },
    setSelectedRows(
      state,
      action: PayloadAction<
        Record<ModivcareBillableTrip['trip_id'], ModivcareBillableTrip>
      >
    ) {
      state.selectedRows = action.payload;
    },
    clearSelectedRows(state) {
      state.selectedRows = {};
    },
    onBulkPriceStart(state, action: PayloadAction<ModivcareBillableTrip[]>) {
      state.bulkPriceModal.billableTripsToPrice = action.payload;
      state.bulkPriceModal.isOpen = true;
    },
    onBulkPriceModalClose(state) {
      state.bulkPriceModal = initialState.bulkPriceModal;
      state.selectedRows = {};
    },
  },
});

export const {
  setFilterSentAtRange,
  setSelectedRows,
  clearSelectedRows,
  onBulkPriceStart,
  onBulkPriceModalClose,
} = modivcareSlice.actions;
